export default {
    route: {
        title: "Mall",
        desc: "Quality selection quality service",
    },

    common: {
        category: "Category",
        subcategory: "Subcategory",
        all: "All",
        search: "Please enter keywords",
        search_goods: "Search goods",
        loading: "Loading...",
        no_more: "No more~",
        add_cart_success: "Add successfully",
        add_cart_fail: "Failed to add",
    },

    more: {
        favorites: "Favorites",
    },

    single: {
        all: "All",
        price: "Price",
        deliver: "Deliver to",
        param: "Parameter",
        spec: "Specification",
        color: "Color",
        size: "Size",
        product: "Product",
        detail: "Detail",
        evaluate: "Evaluate",
        join_cart: "Add To Cart",
        buy: "Buy It Now",
        style: "Style Selection",
        select: "{num} models",
        fav: "Collect",
        service: "Service",
        cart: "Cart",
        address: "Select delivery address",
        addr_add: "Add new address",
    },

    cart: {
        title: "My cart",
        settlement: "Settlement",
        all: "All",
        del_tip: "Remove this product?",
        total: "Total",
        edit: "Edit",
        success_tip: "The item has been added to the shopping cart successfully. Do you want to check out immediately?",
        confirm: "Go to checkout",
        cancel: "Continue shopping",
        select_tip: "Please select the product",
        empty: "No Data Available",
    },

    fav: {
        title: "My Favorites",
        empty: "No favorite products yet",
        del_tip: "Remove this product?",
        del_success: "Removed successfully",
        del_fail: "Failed to remove",
        no_more: "No more products",
        add: "Add to Favorites",
        remove: "Remove from Favorites",
        add_success: "Added successfully",
        add_fail: "Failed to add",
        del: "Delete",
    },
};
